import { Events } from './cutlass';
/**
 * Contextualize cutlass events at this element adding a prefix to the event name
 * and optionally call the custom handler to mutate the event
 */

export default function (element, prefix, handler) {
  if (prefix === void 0) {
    prefix = '';
  }

  element.addEventListener(Events.cutlassEvent, function (e) {
    if (prefix) {
      e.detail.name = prefix.trim().toLowerCase() + ":" + e.detail.name;
    }

    handler && handler(e);
  });
}